import { MDBCol, MDBRow } from 'mdbreact';
import React, { useState } from 'react'

const OpcionesMapas = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;
    const [heightMapa, setHeightMapa] = useState(styles?.heightMapa || 100)
    const [widthMapa, setWidthMapa] = useState(styles?.widthMapa || 100)
    const [zoomMapa, setZoomMapa] = useState(styles?.zoomMapa || 15)

    return (
        <div className='mb-2'>
            <h4>Mapa</h4>
            <MDBRow className='mb-2'>
                <MDBCol>
                    <h6>Alto</h6>
                    <input
                        type="range"
                        value={heightMapa}
                        className="form-range w-100"
                        onChange={(e) => { handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'heightMapa' }); setHeightMapa(e.target.value) }} max="100"
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className='mb-2'>
                <MDBCol>
                    <h6>Ancho</h6>
                    <input
                        type="range"
                        value={widthMapa}
                        className="form-range w-100"
                        onChange={(e) => { handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'widthMapa' }); setWidthMapa(e.target.value) }} max="100"
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className='mb-2'>
                <MDBCol>
                    <h6>Zoom</h6>
                    <input
                        type="range"
                        value={zoomMapa}
                        className="form-range w-100"
                        onChange={(e) => { handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'zoomMapa' }); setZoomMapa(e.target.value) }} max="20"
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol>
                    <div className='mb-2'>
                        <h6>Latitud</h6>
                        <input
                            defaultValue={styles?.latMapa}
                            type="text"
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'latMapa' })}
                        />
                    </div>
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol>
                    <div className='mb-2'>
                        <h6>Longitud</h6>
                        <input
                            defaultValue={styles?.lngMapa}
                            type="text"
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'lngMapa' })}
                        />
                    </div>
                </MDBCol>
            </MDBRow>
        </div>
    )
}

export default OpcionesMapas